/* eslint-disable */
const Locales = require('./Locales');

// These definitions need to be maintained for compatibility with certain node.js scripts
// In the unlikely event of any changes, remember to keep in sync with @ratehub/documents/common
module.exports = {
    ENGLISH: Locales.ENGLISH.substring(0, 2),
    FRENCH: Locales.FRENCH.substring(0, 2),
};
